import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-container-company-policies',
    templateUrl: './container-company-policies.component.html',
    styleUrls: ['./container-company-policies.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ContainerCompanyPoliciesComponent {
    @Input() content = '';

    public contentParagragh =
        'We have updated our privacy policy to: (a) announce that The Truste Privacy Seal granted to Alamo, which means that this Privacy Policy satisfies the requirements of the Truste program For the collection and use of your personal information, (b) better explain the Exchange of information with our subsidiaries and affiliates, holders of licenses, our partner of the European Alliance and its holders of licenses and franchises and our service partners c) announce that this policy complies with the sure port certification between the United States and the Union European and the sure port certification between the United States and Switzerland.';
}
